





























import Vue from 'vue';
import debounce from '../../util/debounce';
export default Vue.extend({
  props: {
    value: {
      required: true,
      type: Number
    },
    step: {
      required: true,
      type: Number
    },
    min: {
      required: true,
      type: Number
    },
    max: {
      required: true,
      type: Number
    }
  },
  methods: {
    handleChangeValue(e: string) {
      debounce('set-val', () => this.$emit('input', Number(e)), 100);
    }
  }
});
